module.exports = "https://cdn.hellotech.com/client-assets/coverage_map_desktop_dc755efea15c31132daccee3288dcee2.png";